var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lottery",
      class: [{ "lottery_is-running": _vm.luck_box_status === "running" }],
    },
    [
      _c("div", { staticClass: "lottery-item" }, [
        _c("div", { staticClass: "lottery-start" }, [
          _c(
            "div",
            {
              staticClass: "lottery-item-btn",
              on: {
                click: function () {
                  _vm.startCallBack()
                  _vm.RollInit()
                },
              },
            },
            [
              _c("c-picture", {
                attrs: {
                  src: require("@/assets/images/lucky_item/target_item_bg.png"),
                  width: "75%",
                  ratio: "354:176",
                  size: "contain",
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "ul",
          _vm._l(_vm.prizes, function (item, i) {
            return _c("li", [
              _c(
                "div",
                {
                  staticClass: "lottery-item-box",
                  class: "rarity_" + item.rarity,
                },
                [
                  _c("c-picture", {
                    staticClass: "item-img",
                    attrs: {
                      src: _vm._f("imgfilter")(item.itempic),
                      width: "100%",
                      ratio: "16:9",
                      size: "contain",
                    },
                  }),
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                  i == _vm.luckygird.index
                    ? _c("div", { staticClass: "roll-in-mask" })
                    : _vm._e(),
                ],
                1
              ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }